import React, { useState } from 'react';
import './DFCStyles.css';
import Footer from '../components/Footer';
import Navbar from '../components/navbar';
import PageHeader from '../about/PageHeader';

// SVG Icons
const IconChevron = () => <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" /></svg>;
const IconShield = () => <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" /></svg>;
const IconSchool = () => <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z" /></svg>;
const IconList = () => <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z" /></svg>;
const IconDesc = () => <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" /></svg>;
const IconPsych = () => <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" /></svg>;
const IconContrast = () => <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10zm1-17.93c3.94.49 7 3.85 7 7.93s-3.06 7.44-7 7.93V4.07z" /></svg>;

const InfrastructureDFC = () => {
  const [isDark, setIsDark] = useState(false);

  const toggleTheme = () => setIsDark(!isDark);

  return (
    <>
      <Navbar />

      <PageHeader
        title="Divyangjan Facilities Center (DFC)"
        crumbs={[{ label: "Home", href: "/" }, { label: "DFC" }]}
      />

      <div>
        <div className="ui-infra-container">
          {/* Purpose Section */}
          <section className="dfc-ref-card">
            <div className="dfc-ref-section-head">
              <IconShield />
              <div className="dfc-ref-section-title">PURPOSE</div>
            </div>
            <div className="dfc-ref-text-block">
              TIMSCDR has set up DFC to provide facilities for Divyangjans for easy accessibility to its premises and services depending upon the Individual requirements for equal opportunities to learn, participate in campus life and to successfully complete the program of study. The DFC is located in the Institute’s office. The Divyangjans will receive concessions and physical help etc. depending upon their disabilities and based upon individual needs and as specified by the regulatory authorities.
            </div>
            <div className="dfc-ref-divider-box">
              <div className="dfc-ref-small-label">DISPLAY OF INFORMATION</div>
              <div className="dfc-ref-text-block" style={{ margin: 0 }}>
                The information in this respect is displayed in the Admission Brochure, Institute Website and on the Notice Board.
              </div>
            </div>
          </section>

          {/* Support From Institute Gallery */}
          <div className="dfc-ref-section-title" style={{ marginBottom: '1.5rem', color: isDark ? '#f1f5f9' : '#1e293b' }}>
            SUPPORT FROM INSTITUTE
          </div>
          <div className="dfc-ref-gallery-grid">
            {[
              { label: 'Wheelchair', src: '/DFC/DFC/Wheelchair/MCA05863.webp' },
              { label: 'Staircase', src: '/DFC/DFC/Staircase/IMG_8683.jpg' },
              { label: 'TIMSCDR building', src: '/DFC/DFC/TIMSCDR-building/image00005.webp' },
              { label: 'Washroom', src: '/DFC/DFC/Washroom/washroom.webp' },
            ].map((item) => (
              <div key={item.label} className="dfc-ref-gallery-item">
                <div className="dfc-ref-img-container">
                  <img
                    src={item.src}
                    alt={item.label}
                    className="dfc-ref-img"
                  />
                </div>
                <div className="dfc-ref-img-caption">{item.label}</div>
              </div>
            ))}
          </div>

          {/* Main Split Layout */}
          <div className="dfc-ref-split-layout">
            {/* Left Column */}
            <div className="dfc-ref-col-stack">
              {/* Facilities Card */}
              <div className="dfc-ref-card">
                <div className="dfc-ref-section-head">
                  <IconSchool />
                  <div className="dfc-ref-section-title">FACILITIES PROVIDED</div>
                </div>
                <ul className="dfc-ref-list">
                  {[
                    "Wheel chair",
                    "Barrier free access to premises and all areas, class rooms, laboratories, library etc.",
                    "Special ladies and gents toilets.",
                    "Extended loan period for Library books and reading material.",
                    "Book bank service.",
                    "Extended time for writing examinations, conduct of practicals.",
                    "Extended time line for submissions.",
                    "Additional support (reader & writer) during examinations.",
                    "Special seating in classrooms.",
                    "Physical support for outdoor activities.",
                    "Mentorship."
                  ].map((text, idx) => (
                    <li key={idx} className="dfc-ref-list-item">
                      <span className="dfc-ref-bullet">•</span> {text}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Student Duty Card */}
              <div className="dfc-ref-card">
                <div className="dfc-ref-section-head">
                  <IconList />
                  <div className="dfc-ref-section-title">STUDENTS’ DUTY</div>
                </div>
                <div>
                  {[
                    "Submit disability report with certificate to the DFC.",
                    "Report to Faculty Mentor with disability profile and concessions required.",
                    "Inform the faculty in advance of academic and other needs.",
                    "Inform DFC and/or Mentor for any specific need and guidance."
                  ].map((text, idx) => (
                    <div key={idx} className="dfc-ref-duty-item">
                      <div className="dfc-ref-dot"></div>
                      <div className="dfc-ref-duty-text">{text}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="dfc-ref-col-stack">
              {/* Office Responsibility Card */}
              <div className="dfc-ref-card">
                <div className="dfc-ref-section-head">
                  <IconDesc />
                  <div className="dfc-ref-section-title">OFFICE RESPONSIBILITY</div>
                </div>
                <ul className="dfc-ref-list">
                  <li className="dfc-ref-list-item">
                    <span className="dfc-ref-bullet">•</span> To assess the student’s request for concessions as per the disability document and to recommend and provide appropriate learning material as well as concessions, academic adjustments, and/or auxiliary aids as per disability and eligibility conditions laid down by the concerned authorities.
                  </li>
                  <li className="dfc-ref-list-item">
                    <span className="dfc-ref-bullet">•</span> To ensure confidentiality of all information pertaining to student’s disabilities.
                  </li>
                  <li className="dfc-ref-list-item">
                    <span className="dfc-ref-bullet">•</span> To assist students in communicating with faculty and Mentor about their disabilities and required concessions.
                  </li>
                </ul>
              </div>

              {/* Faculty Mentors' Responsibility Card */}
              <div className="dfc-ref-card">
                <div className="dfc-ref-section-head">
                  <IconPsych />
                  <div className="dfc-ref-section-title">FACULTY MENTORS’ RESPONSIBILITY</div>
                </div>
                <ul className="dfc-ref-list">
                  {[
                    "To give the students comfortable seat in classroom and lab and condone delay, if any, in entry due to disability.",
                    "To allow or give to the students appropriate and confidential place for assessment and to provide reasonable instructional and/or testing concessions.",
                    "To acknowledge the rights of students with dignity and respect.",
                    "To maintain integrity of academic standards.",
                    "To maintain student confidentiality at all times",
                    "The Mentor Faculty will keep in touch with student to help him/her on the academic. Administrative assistance, psychological guidance. Contact with parents etc."
                  ].map((text, idx) => (
                    <li key={idx} className="dfc-ref-list-item">
                      <span className="dfc-ref-bullet">•</span> {text}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default InfrastructureDFC;